import { inject, Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { Job } from '../job';
import { MessageService } from '../message.service';
import { ManagementService } from '../management.service';
import { QueryMetaData } from '../query-metadata';
import { environment } from '../../environments/environment';
import { PaginationComponent } from '../pagination/pagination.component';

@Component({
    selector: 'app-job-list',
    templateUrl: './job-list.component.html',
    styleUrls: ['./job-list.component.scss'],
    standalone: true,
    imports: [RouterModule, CommonModule, PaginationComponent]
})
export class JobListComponent implements OnInit {

  active: boolean;
  jobs: Job[];
  selectedJob: Job;
  job: Job;
  query: QueryMetaData;

  private route: ActivatedRoute = inject(ActivatedRoute);
  private mgmtService: ManagementService = inject(ManagementService);

  ngOnInit(): void {
    this.route.queryParamMap
      .subscribe((params) => {
               const start = params.get('start') === null ? 0 : parseInt(params.get('start'));
               const size = params.get('size') === null ? environment.pageSize : parseInt(params.get('size'));
        this.query = { start, size } as QueryMetaData;
        this.active = params.get('active') === null ? false : params.get('active') === 'active';
        if (this.active) {
          this.getJobs(this.query);
        } else {
          this.getDeadletterJobs(this.query);
        }
      }
    );
  }

  getDeadletterJobs(query: QueryMetaData): void {
    this.mgmtService.getDeadletterJobs(query)
        .subscribe(jobs => this.jobs = jobs);
  }

  getJobs(query: QueryMetaData): void {
    this.mgmtService.getJobs(query)
        .subscribe(jobs => this.jobs = jobs);
  }

}
